import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  xs: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  gap: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  extraClass: PropTypes.string,
};
const defaultProps = {
  xs: 1,
  sm: null,
  md: null,
  lg: null,
  gap: 0,
  extraClass: null,
};

const Grid = ({ children, xs, sm, md, lg, gap, extraClass, ...rest }) => (
  <div
    className={cx('grid', {
      [extraClass]: !!extraClass,
      'grid-cols-1': xs === 1,
      'grid-cols-2': xs === 2,
      'grid-cols-3': xs === 3,
      'grid-cols-4': xs === 4,
      'grid-cols-5': xs === 5,
      'grid-cols-6': xs === 6,
      'grid-cols-7': xs === 7,
      'grid-cols-8': xs === 8,
      'grid-cols-9': xs === 9,
      'grid-cols-10': xs === 10,
      'grid-cols-11': xs === 11,
      'grid-cols-12': xs === 12,
      'sm:grid-cols-1': sm === 1,
      'sm:grid-cols-2': sm === 2,
      'sm:grid-cols-3': sm === 3,
      'sm:grid-cols-4': sm === 4,
      'sm:grid-cols-5': sm === 5,
      'sm:grid-cols-6': sm === 6,
      'sm:grid-cols-7': sm === 7,
      'sm:grid-cols-8': sm === 8,
      'sm:grid-cols-9': sm === 9,
      'sm:grid-cols-10': sm === 10,
      'sm:grid-cols-11': sm === 11,
      'sm:grid-cols-12': sm === 12,
      'md:grid-cols-1': md === 1,
      'md:grid-cols-2': md === 2,
      'md:grid-cols-3': md === 3,
      'md:grid-cols-4': md === 4,
      'md:grid-cols-5': md === 5,
      'md:grid-cols-6': md === 6,
      'md:grid-cols-7': md === 7,
      'md:grid-cols-8': md === 8,
      'md:grid-cols-9': md === 9,
      'md:grid-cols-10': md === 10,
      'md:grid-cols-11': md === 11,
      'md:grid-cols-12': md === 12,
      'lg:grid-cols-1': lg === 1,
      'lg:grid-cols-2': lg === 2,
      'lg:grid-cols-3': lg === 3,
      'lg:grid-cols-4': lg === 4,
      'lg:grid-cols-5': lg === 5,
      'lg:grid-cols-6': lg === 6,
      'lg:grid-cols-7': lg === 7,
      'lg:grid-cols-8': lg === 8,
      'lg:grid-cols-9': lg === 9,
      'lg:grid-cols-10': lg === 10,
      'lg:grid-cols-11': lg === 11,
      'lg:grid-cols-12': lg === 12,
      'gap-1': gap === 1,
      'gap-2': gap === 2,
      'gap-3': gap === 3,
      'gap-4': gap === 4,
      'gap-5': gap === 5,
      'gap-6': gap === 6,
      'gap-7': gap === 7,
      'gap-8': gap === 8,
      'gap-9': gap === 9,
      'gap-10': gap === 10,
      'gap-11': gap === 11,
      'gap-12': gap === 12,
    })}
    {...rest}
  >
    {children}
  </div>
);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

export default Grid;
